var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container-edit"},[_c('div',{staticClass:"home-apps"},[_c('home-region-application'),_c('home-manager-application'),_c('home-avm-application-vue')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }